module.exports = __webpack_public_path__ + "static/media/logo.7f0d1ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/logo.png
// module id = 175
// module chunks = 0